module.exports = __webpack_public_path__ + "static/img/TLAppLogo_Baseline.620eba01.svg";